/*
  assets/nibec-cotizar-modos.js · Bigbuda T-0449 · Ola 3 (14-oct-2026)
  Modos de cotización de /pages/contacto («WhatsApp primero» y «Solo WhatsApp»; sections/nibec-contacto-form.liquid).
  1) El botón principal de WhatsApp lleva la lista de cotización de quien visita (la misma de nibec-cotizacion.js, clave
     nibecCotizacion): cantidad, nombre, SKU y enlace de cada producto, y debajo las líneas RUT, Razón social, Giro, Comuna y
     Dirección de despacho para completar. Sin lista pide «Productos y cantidades». Al hacer clic, nibec-cotizacion.js agrega
     «Ref. web» y publica nibec_whatsapp_click con ubicacion contacto_principal y modo_cotizacion.
  2) En «WhatsApp primero», el enlace chico muestra u oculta el formulario formal.
*/
(function () {
  if (window.__nibecCotizarModos) return;
  window.__nibecCotizarModos = true;
  var KEY = 'nibecCotizacion';
  // T-0839 (18-oct): mismos campos que el resto de los botones de WhatsApp (assets/nibec-cotizacion.js, CAMPOS).
  var DATOS = '\n\nMis datos para la cotizaci\u00f3n formal:\nNombre: \nEmpresa: \nRUT: \nGiro: \nComuna: \nDirecci\u00f3n de despacho: \nPlazo que necesito: \n\nGracias.';

  function lista() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function linea(i) {
    return '- ' + i.q + ' x ' + i.t + (i.s ? ' (SKU ' + i.s + ')' : '') + ' ' + location.origin + i.u;
  }
  function armar(btn) {
    var m = (btn.getAttribute('href') || '').match(/^https:\/\/(?:wa\.me\/|api\.whatsapp\.com\/send\?phone=)(\d+)/);
    if (!m) return;
    var a = lista();
    var cuerpo = a.length ? 'Hola Nibec, quiero cotizar:\n' + a.map(linea).join('\n') : 'Hola Nibec, quiero cotizar:\nProductos y cantidades: ';
    btn.href = 'https://wa.me/' + m[1] + '?text=' + encodeURIComponent(cuerpo + DATOS);
  }
  function todo() {
    var bs = document.querySelectorAll('[data-nq-wa-principal] [data-nq-wa-btn]');
    for (var i = 0; i < bs.length; i++) armar(bs[i]);
  }
  todo();
  document.addEventListener('nibec:lista', todo);
  window.addEventListener('storage', todo);

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-nq-formal-abrir]') : null;
    if (!b) return;
    var col = b.closest('[data-nq-modo]');
    if (!col) return;
    var abierto = col.classList.toggle('is-formal-abierto');
    b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    if (abierto) {
      var f = col.querySelector('#contact_form input:not([type="hidden"]), #contact_form textarea');
      if (f) f.focus();
    }
  });
})();
